"use client";
import { useState } from "react";
import {Button} from "@mantine/core";
import ProductGrid from "@/components/product/ProductGrid";

export default function BrandProducts({initialProducts, brandSlug, nextPage,labelMap}) {
    const [products, setProducts] = useState(initialProducts);
    const [page, setPage] = useState(2);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(!!nextPage);
    async function loadMore() {
        try {
            setLoading(true);
            const res = await fetch(`/api/brands/${brandSlug}?page=${page}`);
            const data = await res.json();
            const newProducts = data?.brand_products?.data || [];
            setProducts(prev => [...prev, ...newProducts]);
            setHasMore(!!data?.brand_products?.next_page_url);
            setPage(prev => prev + 1);
        } catch(error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }
    return (
        <>
            <ProductGrid products={products} labelMap={labelMap} />
            {hasMore && (
                <div className={'text-center mt-6'}>
                    <Button onClick={loadMore} disabled={loading} tt={'capitalize'}>
                        {loading
                            ? 'Loading...'
                            : 'Load More Products'}
                    </Button>
                </div>
            )}
        </>
    )

}